import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const themeColors: Record<string, string> = {
  "c-black": "#333",
  "c-white": "#fff",
  "c-neutral-100": "#f1f3f4",
  "c-neutral-200": "#e2e6ea",
  "c-neutral-300": "#d4d8dc",
  "c-neutral-400": "#b3bfc7",
  "c-neutral-500": "#b1bbc3",
  "c-neutral-600": "#647887",
  "c-neutral-700": "#50606c",
  "c-primary-100": "#e1edff",
  "c-primary-200": "#bdd8ff",
  "c-primary-300": "#85bcd8",
  "c-primary-400": "#0b7ab1",
  "c-primary-500": "#085c85",
  "c-primary-600": "#063d59",
  "c-secondary-100": "#ebe4ff",
  "c-secondary-200": "#d2c2ff",
  "c-secondary-300": "#9d82c3",
  "c-secondary-400": "#3c0687",
  "c-secondary-500": "#28045a",
  "c-secondary-600": "#063d59",
  "c-green-100": "#ceedd5",
  "c-green-200": "#97bfa0",
  "c-green-300": "#2f7f42",
  "c-green-400": "#235f31",
  "c-green-500": "#173f21",
  "c-yellow-100": "#fcecba",
  "c-yellow-200": "#fadd85",
  "c-yellow-300": "#e7c38e",
  "c-yellow-400": "#cf881d",
  "c-yellow-500": "#9a6516",
  "c-yellow-600": "#67430f",
  "c-red-100": "#fdccd0",
  "c-red-200": "#fcacb2",
  "c-red-300": "#da848b",
  "c-red-400": "#b50917",
  "c-red-500": "#870611",
  "c-red-600": "#5a040b",
  "c-brand-anthem-light": "#eaf0f6",
  "c-brand-anthem-dark": "#2967a0",
  "c-brand-aetna-light": "#f1ecf4",
  "c-brand-aetna-dark": "#754593",
  "c-brand-humana-light": "#f0f5eb",
  "c-brand-humana-dark": "#6b9635",
  "c-brand-uhc-light": "#e6eaf1",
  "c-brand-uhc-dark": "#082872"
} as const;

export const primitive = {
  borderRadius: {
    none: '0',
    xs: '2px',
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px'
  },
  neutral: {
    100: '#f1f3f4',
    200: '#e2e6ea',
    300: '#d4d8dc',
    400: '#b3bfc7',
    500: '#b1bbc3',
    600: '#647887',
    700: '#50606c'
  },
  primary: {
    100: '#e1edff',
    200: '#bdd8ff',
    300: '#85bcd8',
    400: '#0b7ab1',
    500: '#085c85',
    600: '#063d59'
  },
  secondary: {
    100: '#ebe4ff',
    200: '#d2c2ff',
    300: '#9d82c3',
    400: '#3c0687',
    500: '#28045a',
    600: '#063d59'
  },
  green: {
    100: '#ceedd5',
    200: '#97bfa0',
    300: '#2f7f42',
    400: '#235f31',
    500: '#173f21'
  },
  yellow: {
    100: '#fcecba',
    200: '#fadd85',
    300: '#e7c38e',
    400: '#cf881d',
    500: '#9a6516',
    600: '#67430f'
  },
  red: {
    100: '#fdccd0',
    200: '#fcacb2',
    300: '#da848b',
    400: '#b50917',
    500: '#870611',
    600: '#5a040b'
  },
  black: '#333',
  white: '#fff',
  brand: {
    anthem: {
      light: '#eaf0f6',
      dark: '#2967a0'
    },
    aetna: {
      light: '#f1ecf4',
      dark: '#754593'
    },
    humana: {
      light: '#f0f5eb',
      dark: '#6b9635'
    },
    uhc: {
      light: '#e6eaf1',
      dark: '#082872'
    }
  }
}


export const CarelonThemePreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: themeColors['c-primary-400'],
          hoverColor: themeColors['c-primary-500'],
        },
        highlight: {
          background: themeColors['c-primary-200'],
          color: themeColors['c-black'],
        },
        formField: {
          invalidBorderColor: themeColors['c-red-400'],
          invalidPlaceholderColor: themeColors['c-red-400'],
        }
      },
    },
  },
  components: {
    button: {
      root: {
        primary: {
          background: themeColors['c-primary-400'],
          hoverBackground: themeColors['c-primary-500'],
          hoverColor: themeColors['c-white'],
          activeBackground: themeColors['c-primary-400'],
          activeBorderColor: themeColors['c-primary-400'],
        },
        secondary: {
          background: 'transparent',
          borderColor: themeColors['c-primary-400'],
          color: themeColors['c-primary-400'],
          hoverBackground: themeColors['c-primary-100'],
        },
      },
    },
    datatable: {
      header: {
        padding: '1.125rem 1rem',
        background: themeColors['c-neutral-100'],
      },
      headerCell: {
        background: themeColors['c-neutral-100'],
      },
    },
  },
});
